// The account scope is the one global filter: every page that reports money
// reads either all accounts or the single account chosen here.
export const ALL_ACCOUNTS = "all";
export const ACCOUNT_SCOPE_STORAGE_KEY = "finflo.accountScope";

const browserStorage = () => (
  typeof window === "undefined" ? null : window.localStorage
);

export function loadAccountScope(storage) {
  try {
    const selectedStorage = storage === undefined ? browserStorage() : storage;
    return selectedStorage?.getItem(ACCOUNT_SCOPE_STORAGE_KEY) || ALL_ACCOUNTS;
  } catch {
    return ALL_ACCOUNTS;
  }
}

export function saveAccountScope(scope, storage) {
  try {
    const selectedStorage = storage === undefined ? browserStorage() : storage;
    selectedStorage?.setItem(ACCOUNT_SCOPE_STORAGE_KEY, scope);
  } catch {
    // The selector should still work when storage is disabled or unavailable.
  }
}

/**
 * The scope that can actually be applied. A saved account that has since been
 * deleted falls back to all accounts rather than asking the API for a 404.
 */
export function resolveAccountScope(scope, accounts) {
  if (scope === ALL_ACCOUNTS) return ALL_ACCOUNTS;
  return accounts.some((account) => account.id === scope) ? scope : ALL_ACCOUNTS;
}

/** The account id to send to the API, or null for every account. */
export const scopedAccountId = (scope) => (scope === ALL_ACCOUNTS ? null : scope);

/** Query-string parameters for a scoped analytics or ledger request. */
export function withAccountScope(params, scope) {
  const query = new URLSearchParams(params);
  const accountId = scopedAccountId(scope);
  if (accountId) query.set("account_id", accountId);
  return query;
}

/** Where a transaction sits: its account, or both ends of a transfer. */
export function accountLabel(transaction, accountsById) {
  const name = (id) => accountsById[id]?.name || "Deleted account";
  if (!transaction.transfer_id) return name(transaction.account_id);
  const [from, to] = transaction.type === "expense"
    ? [transaction.account_id, transaction.transfer_account_id]
    : [transaction.transfer_account_id, transaction.account_id];
  return `${name(from)} → ${name(to)}`;
}
